/**
 * Vendor Quick Add Popup Controller
 * Handles the custom popup for specific vendor products
 */

(function($) {
    'use strict';

    const VendorQuickAdd = {
        config: null,
        $popup: null,
        $body: null,
        addedVariantIds: new Set(),
        isInitialized: false,

        init: function() {
            if (this.isInitialized) return;

            this.config = window.vendorQuickAdd || {
                targetVendors: ['esdec', 'vectis', 'antai solar', 'mounting systems gmbh'],
                collectionHandle: 'mounting-structure',
                maxProducts: 50,
                enabled: true
            };

            if (!this.config.enabled) return;

            this.$popup = $('[data-vendor-quick-add-popup]');
            this.$body = $('body');

            if (this.$popup.length === 0) {
                console.warn('VendorQuickAdd: Popup element not found');
                return;
            }

            this.bindEvents();
            this.isInitialized = true;
        },

        bindEvents: function() {
            const self = this;

            // Close popup handlers - bind directly to the popup element
            this.$popup.on('click', '[data-close-vendor-popup]', function(e) {
                e.preventDefault();
                e.stopPropagation();
                self.closePopup();
            });

            // Close on overlay click
            $(document).on('click', '.background-overlay', function(e) {
                if (self.$body.hasClass('vendor-quick-add-show')) {
                    self.closePopup();
                }
            });

            // Close on ESC key
            $(document).on('keyup', function(e) {
                if (e.key === 'Escape' && self.$body.hasClass('vendor-quick-add-show')) {
                    self.closePopup();
                }
            });

            // Quantity buttons - bind to popup
            this.$popup.on('click', '[data-qty-minus], [data-qty-plus]', function(e) {
                e.preventDefault();
                self.handleQuantityChange($(this));
            });

            // Quick add form submission - bind to popup
            this.$popup.on('submit', '[data-vendor-add-form]', function(e) {
                e.preventDefault();
                self.handleQuickAdd($(this));
            });
        },

        /**
         * Check if vendor matches target vendors
         */
        isTargetVendor: function(vendor) {
            if (!vendor) return false;
            const vendorLower = vendor.toLowerCase().trim();
            return this.config.targetVendors.some(function(v) {
                const targetLower = v.toLowerCase().trim();
                return vendorLower === targetLower ||
                       vendorLower.includes(targetLower) ||
                       targetLower.includes(vendorLower);
            });
        },

        /**
         * Show the vendor popup with products
         */
        showPopup: function(addedProduct, vendor) {
            const self = this;

            // Update header with added product info
            const productTitle = addedProduct.title || addedProduct.product_title || 'Product';
            this.$popup.find('[data-added-product-title]').text(productTitle);

            // Update title to show vendor name
            const vendorDisplay = vendor.charAt(0).toUpperCase() + vendor.slice(1);
            this.$popup.find('[data-vendor-popup-title]').text('More products from ' + vendorDisplay);

            // Show popup
            this.$body.addClass('vendor-quick-add-show');

            // Fetch vendor products
            this.fetchVendorProducts(vendor);
        },

        /**
         * Fetch products from same vendor in mounting structure collection
         */
        fetchVendorProducts: function(vendor) {
            const self = this;
            const $container = this.$popup.find('[data-vendor-products-container]');
            const vendorLower = vendor.toLowerCase().trim();

            // Show loading
            $container.html(
                '<div class="vendor-popup-loading">' +
                    '<div class="loading-overlay__spinner">' +
                        '<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
                            '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>' +
                        '</svg>' +
                    '</div>' +
                '</div>'
            );

            // Fetch all products from collection, filter client-side
            const url = '/collections/' + this.config.collectionHandle + '?section_id=vendor-quick-add-section';

            $.ajax({
                type: 'GET',
                url: url,
                cache: false,
                success: function(response) {
                    const $html = $(response);
                    const $productsGrid = $html.find('[data-vendor-products-grid]');

                    if ($productsGrid.length) {
                        // Filter products by vendor client-side
                        const $allProducts = $productsGrid.find('[data-product-vendor]');
                        let matchCount = 0;
                        const maxProducts = self.config.maxProducts || 50;

                        $allProducts.each(function() {
                            const $wrapper = $(this);
                            const productVendor = ($wrapper.attr('data-product-vendor') || '').toLowerCase().trim();

                            // Check if vendor matches (contains or equals)
                            const isMatch = productVendor === vendorLower ||
                                           productVendor.includes(vendorLower) ||
                                           vendorLower.includes(productVendor);

                            if (isMatch && matchCount < maxProducts) {
                                $wrapper.css('display', ''); // Show matching products
                                matchCount++;
                            } else {
                                $wrapper.remove(); // Remove non-matching
                            }
                        });

                        if (matchCount > 0) {
                            $container.html($productsGrid.html());

                            // Mark already-added products
                            self.addedVariantIds.forEach(function(variantId) {
                                self.markAsAdded(variantId);
                            });
                        } else {
                            $container.html(
                                '<div class="vendor-no-products">' +
                                    '<p>No additional products from this vendor in this collection.</p>' +
                                '</div>'
                            );
                        }
                    } else {
                        $container.html(
                            '<div class="vendor-no-products">' +
                                '<p>No products found in this collection.</p>' +
                            '</div>'
                        );
                    }
                },
                error: function(xhr, status, error) {
                    console.error('Error fetching vendor products:', error);
                    $container.html(
                        '<div class="vendor-no-products">' +
                            '<p>Unable to load products. Please try again.</p>' +
                        '</div>'
                    );
                }
            });
        },

        /**
         * Handle quantity +/- buttons
         */
        handleQuantityChange: function($btn) {
            const $wrapper = $btn.closest('.vendor-quantity-wrapper');
            const $input = $wrapper.find('.vendor-qty-input');
            let value = parseInt($input.val()) || 1;
            const max = parseInt($input.attr('max')) || 999;
            const min = parseInt($input.attr('min')) || 1;

            if ($btn.is('[data-qty-minus]')) {
                value = Math.max(min, value - 1);
            } else {
                value = Math.min(max, value + 1);
            }

            $input.val(value);
        },

        /**
         * Handle quick add from popup
         */
        handleQuickAdd: function($form) {
            const self = this;
            const $btn = $form.find('[data-vendor-add-btn]');
            const $item = $form.closest('.vendor-product-item');
            const variantId = $form.find('input[name="id"]').val();
            const quantity = parseInt($form.find('input[name="quantity"]').val()) || 1;

            // Prevent double-click
            if ($btn.hasClass('is-loading') || $btn.hasClass('is-added')) return;

            $btn.addClass('is-loading');

            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: {
                    id: variantId,
                    quantity: quantity
                },
                dataType: 'json',
                success: function(item) {
                    // Track as added
                    self.addedVariantIds.add(parseInt(variantId));

                    // Mark as added visually
                    $btn.removeClass('is-loading').addClass('is-added');
                    $item.addClass('is-added');

                    // Update cart count in header
                    self.updateCartCount();
                },
                error: function(xhr) {
                    $btn.removeClass('is-loading');

                    try {
                        const response = JSON.parse(xhr.responseText);
                        if (response.description) {
                            alert(response.description);
                        } else {
                            alert('Could not add to cart. Please try again.');
                        }
                    } catch (e) {
                        alert('Could not add to cart. Please try again.');
                    }
                }
            });
        },

        /**
         * Update cart count in header
         */
        updateCartCount: function() {
            $.ajax({
                type: 'GET',
                url: '/cart.js',
                dataType: 'json',
                success: function(cart) {
                    var count = cart.item_count;
                    $('body').find('[data-cart-count]').text(count);

                    // Also update any cart count bubbles
                    $('.cart-count-bubble').each(function() {
                        var $bubble = $(this);
                        if (count > 0) {
                            $bubble.removeClass('hidden').find('[data-cart-count]').text(count);
                        }
                    });
                }
            });
        },

        /**
         * Mark a product card as added
         */
        markAsAdded: function(variantId) {
            const $item = this.$popup.find('[data-variant-id="' + variantId + '"]').closest('.vendor-product-item');
            if ($item.length) {
                $item.addClass('is-added');
                const $btn = $item.find('[data-vendor-add-btn]');
                $btn.addClass('is-added');
            }
        },

        /**
         * Close the popup
         */
        closePopup: function() {
            this.$body.removeClass('vendor-quick-add-show');
        },

        /**
         * Reset popup state (for next use)
         */
        reset: function() {
            // Optionally clear added states for fresh start
            // this.addedVariantIds.clear();
        }
    };

    // Initialize on DOM ready
    $(document).ready(function() {
        VendorQuickAdd.init();
    });

    // Also initialize after AJAX content loads (for dynamic pages)
    $(document).on('shopify:section:load', function() {
        VendorQuickAdd.init();
    });

    // Expose globally for theme.js integration
    window.VendorQuickAdd = VendorQuickAdd;

})(jQuery);
